module.exports = "../images/arrow-lb-right.png";